<template>
  <div>
    <!--    <el-form-item-->
    <!--      class="custom-label__input width25"-->
    <!--      label="Thông tin bay"-->
    <!--      prop="flightUserList"-->
    <!--    >-->
    <!--      <div class="flex-row flex__left"></div>-->
    <!--    </el-form-item>-->

    <div class="form-input">
      <el-table
        class="table detailRelatedDocs"
        :data="userRoutes"
        v-if="userRoutes && userRoutes.length"
      >
        <el-table-column type="expand">
          <template slot-scope="props">
            <hc-maybay-user-route-extend-info
              :userRoute="props.row"
            ></hc-maybay-user-route-extend-info>
          </template>
        </el-table-column>

        <el-table-column label="Họ tên/Chặng bay">
          <template slot-scope="scope">
            <hc-maybay-user-route-hoten-changbay
              :userRoute="scope.row"
            ></hc-maybay-user-route-hoten-changbay>
          </template>
        </el-table-column>

        <el-table-column label="Thời gian bay/Số vé">
          <template slot-scope="scope">
            <i class="el-icon-time color__blue"></i>
            <break-word-span
              :text="getDateTimeLabel(scope.row.flightTimeRealistic) || '-'"
              :maxLength="25"
            ></break-word-span>
            <br />
            <break-word-span
              :text="`#: ${scope.row.ticketNumber || '-'}`"
              :maxLength="25"
            ></break-word-span>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import handleRequestErrorMixin from "../../handleRequestErrorMixin";
import dateFormatter from "../../../filters/dateFormatter";
import hcCaseFlightRouteUserViewService from "../../../services/maybay/hcCaseFlightRouteUserViewService";
import BreakWordSpan from "../ketluan/break-word-span";
import HcMaybayUserRouteExtendInfo from "./hc-maybay-user-route-extend-info";
import HcMaybayUserRouteHotenChangbay from "./hc-maybay-user-route-hoten-changbay";

export default {
  name: "hc-maybay-user-route-readonly",
  mixins: [handleRequestErrorMixin],
  filters: { dateFormatter },
  components: {
    HcMaybayUserRouteHotenChangbay,
    HcMaybayUserRouteExtendInfo,
    BreakWordSpan
  },
  props: ["hcCaseMasterId"],

  data() {
    return {
      userRoutes: []
    };
  },

  watch: {
    hcCaseMasterId() {
      this.reloadData();
    }
  },

  created() {
    this.reloadData();
  },

  methods: {
    getDateTimeLabel(value) {
      return dateFormatter(value, {
        dateFormat: "DD/MM/YYYY HH:mm",
        nullValue: "-"
      });
    },

    loadUserRoutes() {
      return hcCaseFlightRouteUserViewService
        .findAllByHcCaseMasterId(this.hcCaseMasterId)
        .then(response => (this.userRoutes = response.data));
    },

    reloadData() {
      this.loadUserRoutes();
    }
  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/adminstration/vemaybay/hc-maybay-user-route-readonly.vue